import React, { useState, useEffect } from 'react';
import BaseModal from '../../../components/BaseModal';

const PromptModal = ({
  show,
  onClose,
  onConfirm,
  title = 'Giriş',
  message = 'Lütfen bir değer giriniz:',
  placeholder = '',
  confirmText = 'Onayla',
  cancelText = 'İptal',
  variant = 'primary',
  loading = false,
  type = 'text', // text, textarea, number, email
  required = true,
  defaultValue = '',
  validation = null // function that returns error message or null
}) => {
  const [value, setValue] = useState(defaultValue);
  const [error, setError] = useState('');

  useEffect(() => {
    if (show) {
      setValue(defaultValue);
      setError('');
    }
  }, [show, defaultValue]);

  const handleConfirm = () => {
    if (required && !value.trim()) {
      setError('Bu alan zorunludur');
      return;
    }

    if (validation) {
      const validationError = validation(value);
      if (validationError) {
        setError(validationError);
        return;
      }
    }

    onConfirm(value);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && type !== 'textarea') {
      handleConfirm();
    }
  };

  const variantClasses = {
    primary: 'btn-primary',
    danger: 'btn-danger',
    warning: 'btn-warning',
    success: 'btn-success'
  };

  const renderFooter = () => (
    <div className="d-flex justify-content-end gap-2">
      <button
        type="button"
        className="btn btn-light"
        onClick={onClose}
        disabled={loading}
      >
        {cancelText}
      </button>
      <button
        type="button"
        className={`btn ${variantClasses[variant] || variantClasses.primary}`}
        onClick={handleConfirm}
        disabled={loading}
      >
        {loading ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            İşleniyor...
          </>
        ) : (
          confirmText
        )}
      </button>
    </div>
  );

  return (
    <BaseModal
      show={show}
      onHide={onClose}
      title={title}
      size="md"
      footer={renderFooter()}
      closeOnEscape={!loading}
      closeOnBackdrop={!loading}
      ariaLabel={title}
    >
      <div>
        {message && (
          <p className="mb-3" style={{ lineHeight: '1.6', fontSize: '0.95rem', color: '#6c757d' }}>
            {message}
          </p>
        )}
        
        {type === 'textarea' ? (
          <textarea
            className={`form-control ${error ? 'is-invalid' : ''}`}
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
              setError('');
            }}
            onKeyPress={handleKeyPress}
            placeholder={placeholder}
            rows={4}
            autoFocus
            aria-label={placeholder || 'Giriş alanı'}
            aria-invalid={error ? 'true' : 'false'}
            aria-describedby={error ? 'input-error' : undefined}
          />
        ) : (
          <input
            type={type}
            className={`form-control ${error ? 'is-invalid' : ''}`}
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
              setError('');
            }}
            onKeyPress={handleKeyPress}
            placeholder={placeholder}
            autoFocus
            aria-label={placeholder || 'Giriş alanı'}
            aria-invalid={error ? 'true' : 'false'}
            aria-describedby={error ? 'input-error' : undefined}
          />
        )}
        
        {error && (
          <div id="input-error" className="invalid-feedback d-block mt-2" role="alert">
            <i className="fas fa-exclamation-circle me-1"></i>
            {error}
          </div>
        )}
      </div>
    </BaseModal>
  );
};

export default PromptModal;

